import React from 'react';
import { Label, TextInput } from '@leverege/ui-elements';
import { Plugins } from '@leverege/plugin';
import { ModelTypeSelector } from '@leverege/ui-plugin';
import { useValueChange } from '@leverege/ui-hooks';
import { ns } from '@leverege/i18n';
import Model from "./ExportModel.js";
import S from './ExportEditor.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = ns('ui-attributes.export.OptionsEditor');
export default function OptionsEditor(props) {
  const {
    value
  } = props;
  if (value == null) {
    return null;
  }
  const onModelChange = useValueChange(Model, props);
  return /*#__PURE__*/_jsxs("div", {
    className: S.grid,
    children: [/*#__PURE__*/_jsx(Label, {
      children: t('exportFormat')
    }), ModelTypeSelector.createSelectorAndEditor({
      values: Plugins.get('ExportFormatter'),
      value: Model.getFormatter(value),
      eventData: 'setFormatter',
      onChange: onModelChange,
      allowNone: false
    }, S.fill), /*#__PURE__*/_jsx(Label, {
      children: t('fileName')
    }), /*#__PURE__*/_jsx(TextInput, {
      eventData: "setFilename",
      onChange: onModelChange,
      value: Model.getFilename(value)
    })]
  });
}